<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")
      v-card
        v-card-title.px-5(:style="`background-color: ${$vuetify.theme.themes[$theme].basic600T16}`")
          v-row(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="showModal = !showModal")
                v-icon(color="basic800" :size="24") mdi-close
            v-col.ml-3
              p.mb-0.h6.basic800--text Attach Expenses

        v-card-text.pa-0
          v-container.white(style="max-width:600px")
            v-layout.mt-2
              v-text-field(v-model="searchText" placeholder='Search expense' hide-details dense outlined height="40" background-color="basic200")
                template(v-slot:append)
                  eva-icon(name="search-outline" :fill="$vuetify.theme.themes[$theme].basic600")
          
          v-container.px-1(style="max-width:600px")
            v-layout.my-6(v-if="isFetching")
              v-row.fill-height.ma-0(align='center' justify='center')
                v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
            .contain-layout(v-else)
              v-layout.my-6(v-if="expenses.length == 0")
                v-row.fill-height.ma-0(align='center' justify='center')
                  div.mx-auto
                    v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
                    p.caption Expense not found or empty
              div(v-else)
                template(v-for="(expense, index) in expenses")
                  v-card(flat @click="clickExpense(expense, index)")
                    v-row.align-center.ma-0.px-4.py-1(
                      style="background-color: var(--v-basic600T08)",
                      v-if="isFirstDate(index)"
                    )
                      v-col.ma-0.pa-0
                        .s2.primary400--text {{ getMonth(expense.record_date) }}
                    v-row.align-center.ma-0.px-4.py-3.border-bottom 
                      v-col.ma-0.pa-0
                        .s1.basic800--text {{ shortDescription(expense.category_items) }}
                        .c1.basic600--text.d-inline-flex
                          | {{ getShortDate(expense.record_date) }}
                          span.mx-1(style="font-size: 3px") ●
                          .text-capitalize {{ textLimit(categoryList(expense.category_items), 20) }}
                      v-col.ma-0.pa-0.text-end
                        .s1(
                          :class="getStatus(expense.payment_status, expense.due_at) == 'overdue' ? 'danger500--text' : ''"
                        ) {{ expense.amount | displayPrice }}
                        .c1.danger500--text.text-capitalize(
                          v-if="getStatus(expense.payment_status, expense.due_at) == 'overdue'"
                        ) {{ getStatus(expense.payment_status, expense.due_at) }}
                        .c1.success500--text.text-capitalize(
                          v-if="getStatus(expense.payment_status, expense.due_at) == 'settled'"
                        ) {{ getStatus(expense.payment_status, expense.due_at) }}
                        .c1.primary400--text.text-capitalize(
                          v-if="getStatus(expense.payment_status, expense.due_at) == 'unsent'"
                        ) {{ getStatus(expense.payment_status, expense.due_at) }}
                      v-col.py-0.pr-0.shrink
                        y-checkbox.ma-0.pa-0(v-model="expense.selected" readonly style="margin-right: -8px !important;")
                  //- v-divider.basic300
                
                  //- template(v-for="(product, index) in products")
                    v-list-item.pl-1.pr-3(:key="product.id" :class="product.selected? 'blue lighten-5' : ''" @click="clickProduct(product, index)")
                      v-card.elevation-0.ma-2(style="border-radius: 2px")
                        v-img(:src="product.image ? product.image.file : require('@/assets/image_placeholder.png')" height="70px" width="70px")
                      v-list-item-content
                        div {{ product.name }}
                        div.caption.text--secondary.mr-4(style="line-height: 1.2em;  min-height:14px;") {{ (product.description && product.description.length > 25) ? (product.description.substr(0,25) + '...') : product.description }}
                      v-list-item-action
                        y-checkbox(v-model="product.selected" readonly)
                    v-divider
              div.ma-4
                y-pagination(v-model="page" :pageSize="fetchCount" :count="count")

        v-card-actions
          v-spacer
          v-btn(color='white', text @click='showModal = false')
            .button-Aa-small.primary400--text Cancel
          v-btn.mr-2(color='textColorAccent' depressed height=32  @click="clickDone" :loading="isLoading" dark)
            .button-AA-small.basic100--text Done

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ShowMoreText from '@/components/ShowMoreText'

export default {
  name: 'AttachExpenses',
  props: ['open', 'initialExpenses'],
  components: { ShowMoreText },
  data: () => ({
    isFetching: false,
    fetchCount: 20,
    page: 1,
    // totalPage: 1,
    count: 0,
    expenses: [],
    category: [],
    selectedExpenses: [],
    searchText: '',
    searchCountDown: null,
    isLoading: false,
    months: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  watch: {
    page (val) {
      if (!this.isFetching) {
        this.fetchExpenses(val)
      }
    },
    searchText () {
      if (this.searchCountDown) {
        clearTimeout(this.searchCountDown)
      }
      this.searchCountDown = setTimeout(() => {
        this.searchItem()
      }, 500)
    }
  },
  mounted () {
    this.fetchExpenses(1)
    this.selectedExpenses = [...this.initialExpenses]
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    isFirstDate(index){
      var indexBefore = index - 1
      if (indexBefore < 0) {
        return true
      }else{
        var month = this.expenses[index].record_date.toString().split('-')[1]
        var monthBefore = this.expenses[indexBefore].record_date.toString().split('-')[1]
        if (month == monthBefore) {
          return false
        }else{
          return true
        }
      }
    },
    shortDescription(categories){
      const length = categories.length;
      if (length == 0) {
        return 'Null'
      }
      if (length == 1) {
        return this.textLimit(categories[0].description,30)
      }else{
        var more =  length - 1;
        return this.textLimit(categories[0].description,20) + " +" + more + " more"
      }
    },
    categoryList(data){
      var categoryList = ''
      const length = data.length - 1
      data.forEach((categories,index) => {
        categoryList += categories.category.name
        if (index != length) {
          categoryList += ', '
        }
      });
      if (data.length == 0) {
        categoryList = 'Null'
      }
      return categoryList
    },
    textLimit(text,max){
      if (text.length > max && this.$vuetify.breakpoint.width < 411 && this.$vuetify.breakpoint.width > 330) {
        return `${text.substring(0, max - 1)}...`
      }else if (text.length > max && this.$vuetify.breakpoint.width < 340) {
        return `${text.substring(0, max - 6)}...`
      }
      return text
    },
    getMonth(val) {
      var dateArray = val.toString().split("-");
      var month = this.months[dateArray[1] - 1];
      var year = dateArray[0];
      return month + " " + year;
    },
    getShortDate(val) {
      var dateArray = val.toString().split("-");
      var date = dateArray[2];
      var month = this.months[dateArray[1] - 1].substring(0, 3);
      return date + " " + month;
    },
    getStatus(stat, due) {
      if (stat == 'paid') {
        return "settled";
      } else {
        if(due){
          var currentDate = new Date();
          var duedate = due.split("-");
          var newDueDate = duedate[1] + "/" + duedate[2] + "/" + duedate[0];
          newDueDate = new Date(newDueDate);
          var daydiff = (currentDate - newDueDate) / 1000 / 60 / 60 / 24;
          if (stat == "unpaid" && daydiff > 0.9) {
            return "overdue";
          } else {
            return "unsent";
          }
        } else {
          return "unsent";
        }
      }
    },
    clickExpense (expense, index) {
      this.expenses[index].selected = !this.expenses[index].selected
      this.updateExpense(this.expenses[index])
    },
    updateExpense (expense) {
      if (expense.selected) {
        this.addExpense(expense)
      } else {
        this.removeExpense(expense)
      }
    },
    addExpense (expense) {
      this.selectedExpenses.push(expense.item)
    },
    removeExpense (expense) {
      this.selectedExpenses = this.selectedExpenses.filter((x) => x.id !== expense.id)
    },
    getSelected (expense) {
      let selprod = this.selectedExpenses.filter(f => f.id === expense.id)
      if (selprod.length > 0) {
        return true
      }
      return false
    },
    fetchExpenses(page) {
      this.page = parseInt(page)
      this.isFetching = true
      let fetchUrl = `/books/${this.company.slug}/expenses/?page=${page}&expand=category_items,category_items.category`
      if (this.searchText) {
        fetchUrl += `&search=${this.searchText}`
      }
      this.$axios.get(fetchUrl)
      .then((response) => {
        this.isFetching = false
        this.expenses = response.data.results.map(m => { return { item: m, id: m.id, description: m.description, payment_status: m.payment_status, amount: m.amount, due_at: m.due_at, record_date: m.record_date, category_items: [...m.category_items], selected: this.getSelected(m) }})
        // this.expenses = [...response.data.results]
        this.count = response.data.count
        // const totalCount = response.data.count
        // if (totalCount % this.fetchCount == 0) {
        //   this.totalPage = totalCount/this.fetchCount
        // } else {
        //   this.totalPage = totalCount/this.fetchCount + 1
        // }
        // this.totalPage = parseInt(this.totalPage)
      })
      .catch(() => {})
    },
    searchItem () {
      let searchUrl = `/books/${this.company.slug}/expenses/?page=1&page_size=${this.fetchCount}&company=${this.company.id}&expand=category_items,category_items.category`
      if (this.searchText) {
        searchUrl += `&search=${this.searchText}`
      }
      this.isFetching = true
      this.page = 1
      this.$axios.get(searchUrl)
        .then((response) => {
          this.isFetching = false
          this.expenses = response.data.results.map(m => { return { item: m, id: m.id, description: m.description, amount: m.amount, due_at: m.due_at, record_date: m.record_date, category_items: [...m.category_items], selected: this.getSelected(m) }})
          this.count = response.data.count
          // const totalCount = response.data.count
          // if (totalCount % this.fetchCount == 0) {
          //   this.totalPage = totalCount/this.fetchCount
          // } else {
          //   this.totalPage = totalCount/this.fetchCount + 1
          // }
          // this.totalPage = parseInt(this.totalPage)
        })
        .catch(() => {})
    },
    clickDone () {
      this.showModal = false
      this.$emit('update:initialExpenses', this.selectedExpenses)
    }
  }
}
</script>

<style scoped>
.product-description {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical; 
  overflow: hidden;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.todayDate {
  background-color: var(--v-info500);
  border-radius: 50%;
  color: white !important;
  width: 25px;
  margin: auto;
}
.todayDay {
  color: var(--v-info500) !important;
}
.todayList {
  background-color: var(--v-infoT16) !important;
}
.listItem {
  background-color: var(--v-basic600T08);
  border-radius: 4px;
}
</style>

<i18n>
{
  "en": {
    "product_image": "Product Image",
    "upload": "Upload",
    "edit": "Edit",
    "details": "Details",
    "product_name": {
      "label": "Name",
      "placeholder": "Write product name here"
    },
    "price": {
      "label": "Price",
      "placeholder": "0"
    },
    "slash_price": {
      "label": "Slash Price/Normal Price before Discount",
      "placeholder": "0"
    },
    "weight": {
      "label": "Weight",
      "placeholder": "Min = 0.1 kg | Max = 60 kg"
    },
    "description": {
      "label": "Description",
      "placeholder": "Write product description here"
    },
    "has_inventory": "Has Inventory",
    "no_inventory": "No Inventory",
    "quantity": {
      "label": "Quantity",
      "placeholder": "How many stock left"
    },
    "whos_selling": "Who's Selling",
    "done": "Done"
  }
}
</i18n>
